import React from 'react';
import LabelText from '../../ui/LabelText';
import { IGameModel, IGameModelSimulation } from '../../types/IClubDetail';
import { teamSegmentGameModelGroup } from '../../components/ClubDetail/Performance/GameModel';

interface GameModelValuesAndContentProps {
  gameModelData: IGameModel[] | IGameModelSimulation;
  selectedGameModelAttributes?: string[];
}

const GameModelValuesAndContent: React.FC<GameModelValuesAndContentProps> = ({
  gameModelData,
  selectedGameModelAttributes = ["crosses", "passes_to_final_third", "shots", "defensive_duels"]
}) => {
  const shadowOverrides = {
    boxShadow: 'none',
    '& .simulation_attributes-group-container': {
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none'
      }
    },
    '& .simulation_attribute-table-selection-item .color-indicator': {
      boxShadow: 'none'
    }
  };

  return (
      <div className='bottom-container' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '40px', marginLeft:'-25px' }}>
        <div style={{ width: '1050px' }}>
          <div className='simulation_attributes-table-main' style={{
            width: '100%',
            alignSelf: 'center',
            ...shadowOverrides
          }}>
            {teamSegmentGameModelGroup?.map((section, index) => (
              <div
                className='simulation_attributes-group-container'
                key={index}
                style={{ boxShadow: 'none' }}
              >
                <div className='simulation_group-title-container'>
                  <LabelText className='player-given-name'>{section.title}</LabelText>
                </div>
                <div className='simulation_group-attributes-container'>
                  {section.Segments.map((attr, idx) => (
                    <div
                      className='simulation_attribute-table-selection-item'
                      key={idx}
                      style={{
                        backgroundColor: selectedGameModelAttributes.includes(attr.key) ? 'white' : 'transparent',
                        borderColor: selectedGameModelAttributes.includes(attr.key) ? attr.color : 'transparent',
                        cursor: 'default' // Remove interactivity for PDF
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <input
                          type="checkbox"
                          id={attr.key}
                          className="simulation_custom-checkbox"
                          name="game_model_attribute"
                          value={attr.key}
                          checked={selectedGameModelAttributes.includes(attr.key)}
                          style={{
                            pointerEvents: 'none',
                          }}
                          readOnly
                        />
                        <div style={{
                          height: '9px',
                          width: '9px',
                          borderRadius: '2px',
                          background: attr.color,
                          boxShadow: 'none'
                        }}></div>
                        <LabelText style={{ color: attr.color }}>{attr.label}</LabelText>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
  );
};

export default GameModelValuesAndContent;